export type GoogleAccountButtonProps = { onPress: () => void; disabled: boolean; label: string };
export const googleAccountButtonAvailable = () => false;
export default function GoogleAccountButton(_props: GoogleAccountButtonProps) { return null; }
